import { Card } from '../../atoms/Card';
import { LayoutContainer } from '../../atoms/LayoutContainer';
import { LayoutFlow } from '../../atoms/LayoutFlow';
import { LayoutFlowItem } from '../../atoms/LayoutFlowItem';
import { LayoutImage } from 'components/atoms/LayoutImage';
import { LayoutText } from 'components/atoms/LayoutText';
import { SvgLink } from 'components/atoms/svg/SvgLink';
import { MarkdownWithTypo } from 'components/organisms/MarkdownWithTypo/MarkdownWithTypo';
import { TinaMarkdownContent } from 'tinacms/dist/rich-text';

export function Grid20({
  items = [],
}: {
  items?: Array<{
    id?: string | null;
    imageSrc?: string | null;
    imageAlt?: string | null;
    imagePosition?: string | null;
    linkLabel?: string | null;
    linkHref?: string | null;
    linkUrlLang?: string | null;
    text?: TinaMarkdownContent | TinaMarkdownContent[];
  } | null> | null;
}) {
  if (!items) return null;
  return (
    <LayoutContainer
      backgroundColor="$skin-white-smoke"
      maxContentWidth="$laptop"
      paddingBlock="$spacing-8x"
    >
      <LayoutFlow
        align="center"
        gap="$spacing-4x"
        css={{
          flexDirection: 'column',
          padding: '$spacing-3x',
          '@tabletAndUp': {
            flexDirection: 'row',
            padding: '0',
          },
        }}
      >
        {items.map((item, index) => (
          <LayoutFlowItem key={item?.id ?? index} size="third">
            <Card linkUrl={item?.linkHref} linkUrlLang={item?.linkUrlLang}>
              <LayoutContainer
                paddingBlock="$spacing-4x"
                paddingInline="$spacing-4x"
              >
                <LayoutImage
                  aspectRatio={41 / 25}
                  objectFit="contain"
                  imageAlt={item?.imageAlt}
                  imageUrl={item?.imageSrc}
                  imagePosition={item?.imagePosition ?? undefined}
                />
              </LayoutContainer>

              <LayoutContainer
                paddingBlock="$spacing-4x"
                paddingInline="$spacing-4x"
              >
                <LayoutFlow align="center" gap="$spacing-4x" wrap="wrap">
                  <LayoutFlowItem>
                    {item && item.text && (
                      <MarkdownWithTypo content={item.text} />
                    )}
                  </LayoutFlowItem>
                  <LayoutFlowItem>
                    <LayoutText align="center" color="$skin-accent1-shade1">
                      {item?.linkLabel} <SvgLink />
                    </LayoutText>
                  </LayoutFlowItem>
                </LayoutFlow>
              </LayoutContainer>
            </Card>
          </LayoutFlowItem>
        ))}
      </LayoutFlow>
    </LayoutContainer>
  );
}
